<template>
  <CCol md="7">
    <CCard class="p-4">
      <CCardBody>
        <CForm>
            <img alt="Leadgrease logo" class="mb-4" src="@sset/leadgrease.png" />

            <h4 class="display-5 mr-3">{{$t('confirm_your_email')}}</h4>
            <p class="small text-muted">
                {{ $t("you_will_receive_a_confirmation_message_in_your_mailbox_in_a_few_moments") }}.
            </p>

            <CInput
                type="email"
                :lazy="false"
                :value.sync="$v.form.email.$model"
                :isValid="checkIfValid('email')"
                :placeholder="`${$t('email')}`"
                :invalidFeedback="$t('email_required')"
                :disabled="form._loading"
            />
            
            <CInput
                :isValid="checkIfValid('code')"
                :value.sync="$v.form.code.$model"
                :placeholder="`${$t('confirmation_code')}`"
                :invalidFeedback="$t('confirmation_code_required')"
                :disabled="form._loading"
            ></CInput>
            <CButton
                block 
                color="primary" 
                class="px-4"
                @click="dispatchForm"
                :disabled="form._loading"
            >
                <CSpinner class="mr-1" color="light" size="sm" v-if="form._loading"/>
                {{ $t("confirm") }}
            </CButton>
        </CForm>
      </CCardBody>
    </CCard>
    <hr>
    <div class="small ml-auto my-auto">
        {{ $t("if_you_do_not_receive_the_email,_click_on_the_link_to_resend_the_email") }}.      
        <CLink
            @click="resetCode"
        >
            {{ $t("reset_code") }}
        </CLink>
    </div>
  </CCol>
</template>

<script>

import { validationMixin } from "vuelidate";
import { required, minLength, email, helpers } from "vuelidate/lib/validators";
import pageMixin from '~/mixins/page.js';

export default {
    name: "ActiveAccountPage",
    
    mixins: [ validationMixin, pageMixin ],

    layout: "basic",

    middleware: ['guest'],


    data(){
        return{
            form: {
                email: "",
                code: "",
                _loading:false
            },
            
        }  
    },
    computed:{
        email:function(){
            return this.$route.params.email;
        },
        code:function(){
            return this.$route.params.code;
        }
    },

    validations: {
        form: {
            email: {
                required,
                email
            },
            code: {
                required,
            }
        }
    },

    methods: {
        
        resetCode(){
            console.log("Reset code....")
        },

        async dispatchForm(){

            this.form._loading = true;
            let response = await this.sendForm({
                url:'/activeAccount',
                method:'POST',
                custom_message:{
                    header:"¡_account_active!",
                    body:"active_account,_you_can_login",
                    color:'success', 
                }
            });
            this.form._loading = false;
            
            if(response.status)
                this.$router.push({ name: 'login' });

            /* this.form._loading = true;
            setTimeout(()=>{ 
                this.form._loading = false;
                this.$store.dispatch('toast/addFixedToasts', {
                    header:"¡_account_active!",
                    body:"active_account,_you_can_login",
                    color:'success', 
                });
                this.$router.push({ name: 'login' }); 
            }, 3000); */
        }

        

    },
    mounted(){
        this.form.email = this.email;
        this.form.code = this.code;
    },
    
};
</script>